import React from 'react';
import { config } from "config.js";
import ulLogo from '../../assets/img/UNI_Logo_Inter_LCSB_rgb_white_reddot.svg';

export default function Footer() {
  return (
    // .footer-bar — the design system's dark bottom strip (primary-950).
    <footer id="footer" className="footer-bar mt-auto py-8">
      <div className="max-w-5xl mx-auto px-4 text-center">
        <nav className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-sm mb-4">
          <a href="https://wwwen.uni.lu/lcsb" className="hover:text-white transition-colors">Contact Us</a>
          <span className="opacity-40">|</span>
          <a href="https://wwwen.uni.lu/lcsb" className="hover:text-white transition-colors">Terms of Use</a>
          <span className="opacity-40">|</span>
          <a href="https://wwwen.uni.lu/lcsb" className="hover:text-white transition-colors">Privacy Policy</a>
        </nav>

        {config.EXTRA_FOOTER && (
          <div
            className="text-sm mb-4"
            dangerouslySetInnerHTML={{ __html: config.EXTRA_FOOTER }}
          />
        )}

        <a href="https://wwwen.uni.lu/lcsb" className="inline-block">
          <img
            src={ulLogo}
            alt="University of Luxembourg - LCSB"
            className="h-12 mx-auto"
          />
        </a>
      </div>
    </footer>
  );
}
